import {getBiToken} from '../env/biToken/biToken';
import {getCompId} from '../env/compId/compId';
import {getArtifactsVersions} from '../env/getWindowVersion/getWindowVersion';
import {getInstanceId} from '../env/instanceId/instanceId';
import {getPlayerVersion} from '../env/playerVersion/playerVersion';
import {getSessionId} from '../env/sessionId/sessionId';
import {getVisitorId} from '../env/visitorId/visitorId';
import {getAlbumId} from './_getAlbumId';
import {biErrorLoggerFactory} from './biErrorLoggerFactory';

const params = {
  instanceId: getInstanceId(),
  visitorId: getVisitorId(),
  biToken: getBiToken(),
  compId: getCompId(),
  sessionId: getSessionId(),
  playerVersion: getPlayerVersion(),
  artifactVersion: getArtifactsVersions(),
  albumId: getAlbumId(),
};
export const biErrorLogger = biErrorLoggerFactory(params);
